import { Component, OnInit } from "@angular/core";
import { ScriptLoaderService } from "src/app/_services/script-loader.service";

@Component({
	selector: "app-linkedin",
	templateUrl: "./linkedin.component.html",
	styleUrls: ["./linkedin.component.scss"],
})
export class LinkedInComponent implements OnInit {
	linkedInPosts: any[] = []; // Liste des posts
	isLoading = true; // Indicateur de chargement
	error: string | null = null; // Gestion des erreurs

	constructor(
    private scriptLoader: ScriptLoaderService
	) {}

	ngOnInit(): void {
		this.scriptLoader.loadScript('https://elfsightcdn.com/platform.js"')
      .then(() => {
        console.log('Script chargé');
      })
      .catch(() => {
        console.error('Erreur de chargement du script');
      });
	}
}
